export enum Role {
	Client = 'urn:aon:client:aqua-tmt-backoffice-api:access',
	Admin = 'urn:aon:role:neo9-backoffice-aqua-admin',
	Configuration = 'urn:aon:role:neo9-backoffice-aqua-config',
	ClaimPortalAdmin = 'urn:aon:role:neo9-backoffice-aqua-info-claim-portals',
}
